module.exports = __webpack_public_path__ + "img/da.37a18658.svg";